// Typelizer digest 5d17bd8384a26306690641ece367150b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /bank_statement_files/:bank_statement_file_id/assignment */
  update: (
    params: { bankStatementFileId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/bank_statement_files/:bank_statement_file_id/assignment', params, options),
    method: 'patch',
  }),
}
